<template>
  <div class="footer">
    <div class="leave-container row-center">
      <div class="row-between leave-wrapper">
        <div class="leave-left">
          <p>021-32513000</p>
          <p>{{ $t("Hotline:Working days，AM 9:00-PM 5:00") }}</p>
        </div>
        <div class="row-between leave-box">
          <div class="leave-box-left row">
            <img
              style="width: 15px; height: 11px"
              src="../assets/images/icon_footer_mail.png"
            />
            <el-input
              v-model="email"
              style="width: 360px"
              :placeholder="$t('Please Enter Your E-Mail！')"
            ></el-input>
            <!-- <p>{{ $t('Please Enter Your E-Mail！') }}</p> -->
          </div>
          <div class="leave-box-right" @click="subscription">
            {{ $t("Subscription") }}
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <el-row>
        <el-col :span="8">
          <div class="info">
            <h4>{{ $t("business") }}</h4>
            <div class="line"></div>
            <div class="row">
              <div class="left-arrow" style="width: 45%">
                <template
                  v-for="venue of venues.slice(0, Math.ceil(venues.length / 2))"
                >
                  <p
                    :key="venue.id"
                    style="cursor: pointer"
                    @click="
                      () => $router.push(`/business?venue.id=${venue.id}`)
                    "
                  >
                    <span class="text">
                      {{
                        $i18n.locale == "zh"
                          ? `${venue.number} ${venue.name}`
                          : `${venue.number} ${venue.nameEn}`
                      }}
                    </span>
                  </p>
                </template>
              </div>
              <div class="left-arrow" style="width: 55%">
                <template
                  v-for="venue of venues.slice(
                    Math.ceil(venues.length / 2),
                    venues.length
                  )"
                >
                  <p
                    :key="venue.id"
                    style="cursor: pointer"
                    @click="
                      () => $router.push(`/business?venue.id=${venue.id}`)
                    "
                  >
                    <span class="text">
                      {{
                        $i18n.locale == "zh"
                          ? `${venue.number} ${venue.name}`
                          : `${venue.number} ${venue.nameEn}`
                      }}
                    </span>
                  </p>
                </template>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="info">
            <h4>{{ $t("onlineshow") }}</h4>
            <div class="line"></div>
            <div
              class="row"
              style="
                align-items: flex-start;
                justify-self: space-between;
                gap: 15px;
              "
            >
              <div class="left-arrow" style="width: 50%">
                <template
                  v-for="exhibitCategory of exhibitCategories.slice(
                    0,
                    Math.ceil(exhibitCategories.length / 2)
                  )"
                >
                  <p
                    :key="exhibitCategory.id"
                    style="cursor: pointer"
                    @click="
                      () =>
                        $router.push(
                          `/onlineshow?exhibitCategory.id=${exhibitCategory.id}`
                        )
                    "
                  >
                    <span class="text">
                      {{
                        $i18n.locale == "zh"
                          ? `${exhibitCategory.content}`
                          : `${exhibitCategory.contentEn}`
                      }}
                    </span>
                  </p>
                </template>

                <!-- <p>{{ $t("Hot Products") }}</p>
                <p>{{ $t("Bicycles") }}</p>
                <p>{{ $t("Frames,Forks & Parts") }}</p>
                <p>{{ $t("Tires,Rims & Parts") }}</p>
                <p>{{ $t("Transmissions & Parts") }}</p>
                <p>{{ $t("Steering & Components") }}</p> -->
              </div>
              <div class="left-arrow" style="width: 50%">
                <template
                  v-for="exhibitCategory of exhibitCategories.slice(
                    Math.ceil(exhibitCategories.length / 2),
                    exhibitCategories.length
                  )"
                >
                  <p
                    :key="exhibitCategory.id"
                    style="cursor: pointer"
                    @click="
                      () =>
                        $router.push(
                          `/onlineshow?exhibitCategory.id=${exhibitCategory.id}`
                        )
                    "
                  >
                    <span class="text">
                      {{
                        $i18n.locale == "zh"
                          ? `${exhibitCategory.content}`
                          : `${exhibitCategory.contentEn}`
                      }}
                    </span>
                  </p>
                </template>

                <!-- <p>{{ $t("Accessories") }}</p>
                <p>{{ $t("Machinery & Tools") }}</p>
                <p>{{ $t("Cycling/Outdoor Products") }}</p>
                <p>{{ $t("Electric Bicycle") }}</p>
                <p>{{ $t("Components & Parts Of E-Bike") }}</p> -->
                <!-- <p>{{ $t("Motor Cycle") }}</p> -->
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="info">
            <h4>{{ $t("artilce") }}</h4>
            <div class="line"></div>
            <div class="row">
              <div class="left-arrow">
                <template v-for="articleCategory of articleCategories">
                  <p
                    :key="articleCategory.id"
                    style="cursor: pointer"
                    @click="
                      () =>
                        $router.push(
                          `/viewsmore?category.id=${articleCategory.id}`
                        )
                    "
                  >
                    <span class="text">
                      {{ articleCategory.name }}
                    </span>
                  </p>
                </template>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <img
            style="width: 118px; height: 118px"
            src="../assets/images/icon_qrcodes.png"
            alt
          />
          <div class="info" style="font-size: 12px">
            {{ $t("Scan this to mobile website") }}
          </div>
        </el-col>
        <el-col :span="5" class="contact-box">
          <div class="info">
            <h4>{{ $t("Contact Us") }}</h4>
            <div class="line"></div>
            <div class="row">
              <div>
                <div class="row" style="align-items: flex-start">
                  <img
                    style="width: 8px; height: 11px; margin: 6px 4px 4px 4px"
                    src="../assets/images/icon_address.png"
                    alt
                  />
                  <p>
                    {{
                      $t("21st floor, No.1678 Jinshajiang Road, Shanghai200333")
                    }}
                  </p>
                </div>
                <div class="row">
                  <img
                    style="width: 8px; height: 11px; margin: 6px 8px 4px 4px"
                    src="../assets/images/icon_mobile.png"
                    alt
                  />
                  <p>021-32513000</p>
                </div>
                <div class="row">
                  <img
                    style="width: 13px; height: 11px; margin: 6px 4px 4px 2px"
                    src="../assets/images/icon_mail.png"
                    alt
                  />
                  <p>info@e-chinacycle.com</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="site-container">
      <div class="site-info">
        <div style="margin-bottom: 14px; font-size: 16px; cursor: pointer">
          <span @click="$router.push('/document/1')">
            {{ $t("About Us") }}
          </span>
          |
          <span @click="$router.push('/document/2')">
            {{ $t("For Suppliers") }}
          </span>
          |
          <span @click="$router.push('/document/3')">
            {{ $t("For Buyers") }}
          </span>
          |
          <span @click="$router.push('/document/4')">
            {{ $t("Media Cooperation") }}
          </span>
          |
          <span style="cursor: default">
            {{ $t("Online Exhibition") }}
          </span>
          |
          <span @click="$router.push('/document/5')">
            {{ $t("Contact Us") }}
          </span>
          <!-- | -->
          <!-- <span @click="$router.push('/document/6')">
            {{ $t("Download") }}
          </span> -->
        </div>
        <div style="font-size: 12px">
          e-chinacycle.com All rights reserved. 沪ICP备11048102号-1 沪公网安备
          31010702001213
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reserve, getDictData } from "@/http/api";
import { mapState } from "vuex";

import { listToTree } from "@/libs/utils";

export default {
  data() {
    return {
      email: "",
      exhibitCategories: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      venues: (state) => state.venues,
      // exhibitCategories: state => state.exhibitCategories.toTree()
      articleCategories: (state) => state.articleCategories,
    }),
  },
  mounted() {
    this.fetchExhibitCategory();
  },
  methods: {
    async fetchExhibitCategory() {
      const res = await getDictData({ type: "EXHIBIT_CATEGORY" });
      console.log("========================res", res);
      this.exhibitCategories = listToTree(res, "superiorId");
      console.log(this.exhibitCategories);
    },
    gomedia() {
      this.$router.push("/commedia");
    },
    async subscription() {
      if (!this.email) return this.$message.error("请填写邮箱地址");

      const pattern =
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

      if (!pattern.test(this.email)) {
        return this.$message.error("请输入正确的邮箱");
      }

      const params = { contactEmail: this.email };

      if (this.user && this.user.id) {
        // params.user = { id: this.user.id };
        params.contactName = this.user.name;
      }

      const res = await reserve(params);
      if (!res);
      this.$message.success("发送成功");
      this.email = "";
    },
  },
};
</script>
<style lang="less" scoped>
.leave-box /deep/ .el-input__inner {
  border: unset;
}
.footer {
  min-width: 750px;
  background-color: #262626;
  color: #fff;
  .content {
    height: 100%;
    width: 1200px;
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding: 20px 0;
    box-sizing: border-box;
    .info {
      height: 100%;
      h4 {
        margin-bottom: 10px;
        font-size: 14px;
      }
      p,
      .text {
        font-size: 12px;
        line-height: 24px;
      }
      .text {
        display: block;
        margin-left: 10px;
        width: 85%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    img {
      width: 100px;
      height: 100px;
    }
  }
}
.site-container {
  background: #444444;
}
.site-info {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 19px 0;
}
.line {
  width: 40px;
  height: 3px;
  background: #619a37;
  margin-bottom: 14px;
}
.contact-box {
  height: 230px;
  margin: -20px 0;
  padding: 20px;
  background: rgb(63, 95, 40);
}
.leave-container {
  height: 100px;
  background: #dddddd;
  .leave-wrapper {
    width: 1200px;
    margin: 0 auto;
  }
}
.leave-left {
}
.leave-left p:first-child {
  font-size: 18px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #619a37;
}
.leave-left p:nth-child(2) {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  margin-top: 10px;
}
.leave-box {
  width: 550px;
  height: 52px;
  background: #ffffff;
  border: 6px solid #619a37;
  border-right: unset;
  cursor: pointer;
  .leave-box-left {
    padding-left: 20px;
    img {
    }
    p {
      font-size: 14px;
      font-family: FZLanTingHei-DB-GBK;
      font-weight: 400;
      color: #999999;
      padding-left: 8px;
    }
  }
  .leave-box-right {
    width: 135px;
    height: 52px;
    line-height: 40px;
    background: #444444;
    border: 6px solid #619a37;
    font-size: 14px;
    font-family: FZLanTingHei-DB-GBK;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
}
.left-arrow p {
  // left: 10px;
  position: relative;
  // width: 90%;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // max-width: 95%;
  // overflow: hidden;
  // white-space: normal;
  // text-overflow: ellipsis;
}
.left-arrow p::before {
  position: absolute;
  // left: -10px;
  top: 7px;
  content: "";
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-left: 5px solid #ffffff;
}

::v-deep {
  .el-col {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue